import { ConfigurationEnum, IEnvironment } from '@environments/IEnvironment';
import { defaultValues } from '@environments/defaultValues';
import { featureFlags } from '@environments/featureFlags.qvs';
import { accessApp } from '@environments/accessApp.qvs';
import { contractNumberPatterns } from '@environments/contractNumberPatterns.qvs';
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.

export const environment: IEnvironment = {
  ...defaultValues,
  accessApp,
  contractNumberPatterns,
  configuration: ConfigurationEnum.TEST_EBANKING,
  localStorageWhiteList: ['auth'],
  appTitle: 'EFG E-Banking',
  featureFlags
};
